"use client";

import React, { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CallToAction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  useEffect(() => {
    const link = document.createElement('link');
    link.href = 'https://assets.calendly.com/assets/external/widget.css';
    link.rel = 'stylesheet';
    document.head.appendChild(link);
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.type = 'text/javascript';
    script.async = true;
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(link);
      document.head.removeChild(script);
    };
  }, []);
  const handleCalendlyClick = () => {
    if ((window as any).Calendly) {
      (window as any).Calendly.initPopupWidget({
        url: 'https://calendly.com/mfloresdo/30min'
      });
    }
  };
  return <section className="pt-16 pb-8 px-4 sm:px-6 lg:px-8 bg-background">
      <div className="container max-w-4xl mx-auto">
        <div ref={ref} className={`text-center transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground mb-6">
            Ready to Optimize Your Health?
          </h2>
          
          <p className="text-base sm:text-lg text-muted-dark mb-8 max-w-2xl mx-auto leading-relaxed">
            Take the first step towards reclaiming your vitality, energy, and confidence. Our expert team is ready to create a personalized treatment plan that transforms your well-being.
          </p>
          
          <Button size="lg" className="bg-accent text-accent-foreground hover:bg-accent-hover active:bg-accent-active shadow-medium hover:shadow-strong transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] px-8 py-6 text-lg font-semibold rounded-md hover:-translate-y-1" onClick={handleCalendlyClick}>Schedule a Free Consultation</Button>
          
          <p className="mt-4 text-sm sm:text-base text-muted-dark italic max-w-2xl mx-auto">
            <em>Physician-led care. Secure telemedicine. State-compliant medical oversight.</em>
          </p>
        </div>
      </div>
    </section>;
}